var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-tags-input',{attrs:{"tags":_vm.tags},on:{"tags-changed":_vm.newTags},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }